import { useModuleData } from '@rebuild/hooks/data/useModuleData';

export const useQuestionModuleData = () => {
	const { question } = useModuleData();

	const fetchQuestionList = async params => {
		await question.refresh(params || {});
		const data = question.data || {};
		return {
			rows: data.rows || [],
			total: data.total || 0,
			rawData: data
		};
	};

	return {
		question,
		fetchQuestionList
	};
};
